module.exports = __webpack_public_path__ + "static/media/footerBackground.ce6566c7.svg";